import { createSelector, MemoizedSelector  } from '@ngrx/store';

import { IBakery, IDeliveryOrder } from '@cakeiteasy/web-utils';
import { ICartLine } from '../../models/cart/i-cart-line';
import { IPickupDelivery } from '../../models/delivery/i-pickup-delivery';
import { IDeliveryToDoor } from '../../models/delivery/i-delivery-to-door';
import { IMailDeliveryToDoor } from '../../models/delivery/i-mail-delivery-to-door';

import { getCartState } from '../reducers';
import { CartState } from '../reducers/cart.reducer';

export const getCart = createSelector(
  getCartState,
  (state: CartState) => state.cart
);

export const getCartInvoiceFee = createSelector(
  getCartState,
  (state: CartState) => state.cart && state.cart.invoiceFee
);

export const getCartTotalPrice: MemoizedSelector<CartState, number> = createSelector(
  getCartState,
  (state: CartState) => state.cart && state.cart.totalPrice
);

export const getCartBakery: MemoizedSelector<CartState, IBakery> = createSelector(
  getCartState,
  (state: CartState) => state.cart && state.cart.bakery
);

export const getCartDelivery: MemoizedSelector<CartState, IPickupDelivery | IDeliveryToDoor | IMailDeliveryToDoor> = createSelector(
  getCartState,
  (state: CartState) => state.cart && state.cart.delivery
);

export const getDeliveryOrder: MemoizedSelector<CartState, IDeliveryOrder> = createSelector(
  getCartState,
  (state: CartState) => state.cart && state.cart.deliveryOrder
);

export const getCartLines: MemoizedSelector<CartState, ICartLine[]> = createSelector(
  getCartState,
  (state: CartState) => state.cart ? state.cart.lines : []
);

export const getCartIsEmpty = createSelector(
  getCartState,
  (state: CartState) => state.cart && state.cart.lines && state.cart.lines.length === 0);

export const getCartLoaded = createSelector(
  getCartState,
  (state: CartState) => state.loaded
);
export const getCartLoading = createSelector(
  getCartState,
  (state: CartState) => state.loading
);
